// Which site a hostname is. Vanity Studio is served by the same Pages project on
// its own subdomain (vanity.streamnook.app), and on vanity.localhost while
// developing (browsers resolve every *.localhost name to this machine).

/** True on the Vanity Studio host. */
export function isVanityHost(hostname: string): boolean {
  return hostname.toLowerCase().startsWith('vanity.');
}

/** The main site's home page seen from the studio: the same protocol and host
 *  (port included) without the leading `vanity.`. */
export function siteHomeUrl(protocol: string, host: string): string {
  return `${protocol}//${host.replace(/^vanity\./i, '')}/`;
}
